import { gql } from '@apollo/client';

export const GET_ALL_VENDORS = gql`
  query GetVendors {
    getAllVendors {
      vendorId
      vendorName
      firstName
      lastName
      email
      phone
      projects {
        id
        status
        certificate {
          expirationTime {
            notAfter
          }
        }
      }
    }
  }
`;
